import React from 'react';
import styled from 'styled-components';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { colors } from '../../utils/colors.js';

const Card = styled.div`
  background: ${colors.white};
  border-radius: 12px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const Title = styled.h2`
  font-size: 15px;
  font-weight: 600;
  color: ${colors.gray[800]};
  margin: 0;
`;

const PeriodSelect = styled.select`
  border: 1px solid ${colors.gray[300]};
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 13px;
  color: ${colors.gray[700]};
`;

const Empty = styled.div`
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.gray[500]};
  font-size: 13px;
`;

function formatDateLabel(dateStr) {
  const [, month, day] = dateStr.split('-');
  return `${day}/${month}`;
}

export default function DailyChart({ title, data, dias, onChangeDias, color }) {
  const hasData = data && data.length > 0;

  return (
    <Card>
      <Header>
        <Title>{title}</Title>
        <PeriodSelect value={dias} onChange={(e) => onChangeDias(Number(e.target.value))}>
          <option value={7}>Últimos 7 dias</option>
          <option value={30}>Últimos 30 dias</option>
          <option value={90}>Últimos 90 dias</option>
        </PeriodSelect>
      </Header>

      {!hasData && <Empty>Sem dados no período selecionado.</Empty>}

      {hasData && (
        <ResponsiveContainer width="100%" height={240}>
          <LineChart data={data} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke={colors.gray[100]} />
            <XAxis dataKey="date" tickFormatter={formatDateLabel} tick={{ fontSize: 11, fill: colors.gray[500] }} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: colors.gray[500] }} />
            <Tooltip labelFormatter={formatDateLabel} />
            <Line
              type="monotone"
              dataKey="total"
              stroke={color || colors.primary[500]}
              strokeWidth={2}
              dot={{ r: 3 }}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </Card>
  );
}
